import { RefCodeItemComponentBase } from './ref-code-item.component.base';
import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, onValueChangeEvent, UserStorage } from '@scisys-uim/uim-common';
import { RefCodeService } from 'assets-service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Component({
  selector: 'app-ref-code-item',
  templateUrl: './ref-code-item.component.html',
  styleUrls: ['./ref-code-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class RefCodeItemComponent extends RefCodeItemComponentBase {

  @ViewChild('domainAutocompleteInput') domainAutocompleteInput: MatInput;
  private domainSelectionListSubject: Subject<string[]> = new BehaviorSubject([]);
  domainSelectionList: Observable<string[]> = this.domainSelectionListSubject.asObservable();
  allDomains: string[] = [];

  constructor(protected refCodeService: RefCodeService,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(refCodeService, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.domainSelectionListLoad();
  }

  itemSet() {
    super.itemSet();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.wireDomainAutocomplete();
  }

  domainSelectionListLoad() {
    this.refCodeService.getAllDomains().subscribe(
      data => {
        this.allDomains = data;
        this.domainSelectionListFilter(null);
      }
    );
  }

  wireDomainAutocomplete(): void {
    if (this.domain) {
      onValueChangeEvent(this.domain, value => {
        if (value == "") {
          value = null;
          this.item.domain = null;
        }
        this.domainSelectionListFilter(value);
      }, {
        debounceMillis: 100
      });
    }
  }

  domainSelectionListFilter(text: string): void {
    var filtered = this.allDomains;
    if (text != null && text.length > 0) {
      filtered = filtered.filter(p => p.toLowerCase().includes(text.toLowerCase()));
    }
    this.domainSelectionListSubject.next(filtered);
  }
}





